import axios from "axios";
import md5 from 'js-md5';
// import Qs from 'qs';
// import crypto from 'crypto';
const TOKEN = '68ec0d63d30e3b4d32234dcc24f5a3c6466cf966';
const LOG = process.env.NODE_ENV == 'development' ? true : false;


// const baseURL='http://192.168.0.121/service_api/';
const baseURL='https://weiye.weipaiyuan.cn/';
// const baseURL='http://localhost/vue_page_api/';

const http_request = axios.create({
	baseURL:baseURL,
	headers : {
		'Accept' : 'application/json',
		'Content-Type' : 'application/json; charset=UTF-8'
	},
	method : 'post',
	timeout : 600000,
})

const http_get = axios.create({
	baseURL:baseURL,
	headers : {
		'Accept' : 'application/json',
		'Content-Type' : 'application/json; charset=UTF-8'
	},
	method:'get',
	timeout : 60000,
})

const request = {
	post:async function (port,method,data={}){
		try {
			if (LOG){
				console.log('   ');
				console.log('----request post start----')
				console.log('port method',port,method);
				console.log('data',data);
			}
			let url = await set_url(port,method,data,'post');
			if (!url){
				return {
					errcode:100,
					errmsg:'url error',
					style: 'cancel'
				}
			}
			let res = await http_request.post(url, data);
			if (LOG){
				console.log('res',res);
				console.log('----request post end----');
				console.log(' ');
			}
			if (res.status == 200){
				return res.data;
			}else{
				return {
					errcode : 200,
					errmsg : 'net work error',
					style :'cancel'
				}
			}
		}catch (e) {
			console.log(e);
			return {
				errcode:100,
				errmsg:'error e',
				style: 'cancel'
			}
		}
	},
	get:async function (port,method,data={}){
		try{
			if (LOG){
				console.log(' ');
				console.log('----request get start----');
				console.log('port method',port,method);
				console.log('data',data);
			}
			let url = await set_url(port,method,data,'get');
			if (!url){
				return {
					errcode:200,
					errmsg:'url error',
					style : 'cancel'
				}
			}
			let res = await http_get.get(url)
			if (LOG){
				console.log('res',res);
				console.log('----request get end----');
				console.log(' ');
			}
			if (res.status == 200){
				return res.data
			}else{
				return {
					errcode:200,
					errmsg:'net work error',
					style : 'cancel'
				}
			}
		}catch (e){
			return {
				errcode:100,
				errmsg:'error e',
				style : 'cancel'
			}
		}
	},
	upload : async function  (file, method='',dir='',uid=''){
		if (!file){
			return {
				errcode : 200,
				errmsg : '请选择文件',
				style : 'cancel'
			};
		}
		if (LOG){
			// console.log(' ');
			// console.log('----request upload start----');
			// console.log('file',file);
			// console.log('dir',dir);
		}
		method = method ? method : 'img';
		let formData = new FormData();
		formData.append('file',file);
		formData.append('dir',dir);
		formData.append('uid',uid);
		if (LOG){
			// console.log('formData',formData);
		}
		let url = await set_url('upload',method,{},'post');
		let res = await http_request.post(url,formData);
		if (LOG){
			// console.log('res',res);
			// console.log('----request upload end----');
			// console.log(' ');
		}
		if (res.status == 200){
			return res.data;
		}else{
			return {
				errcode : 200,
				errmsg : '请选择文件',
				style : 'cancel'
			};
		}
	},
	pdf_upload : async function  (file, dir=''){
		if (!file){
			return {
				errcode : 200,
				errmsg : '请选择文件',
				style : 'cancel'
			};
		}
		if (LOG){
			// console.log(' ');
			// console.log('----request upload start----');
			// console.log('file',file);
			// console.log('dir',dir);
		}
		let formData = new FormData();
		formData.append('file',file);
		formData.append('dir',dir);
		if (LOG){
			// console.log('formData',formData);
		}
		let url = await set_url('ebook','pdf_upload',{},'post');
		let res = await http_request.post(url,formData);
		if (LOG){
			// console.log('res',res);
			// console.log('----request upload end----');
			// console.log(' ');
		}
		if (res.status == 200){
			return res.data;
		}else{
			return {
				errcode : 200,
				errmsg : '请选择文件',
				style : 'cancel'
			};
		}
	}

}

async function set_url(port,method,data,type='post'){
	if (!port || !method){
		return false;
	}
	if (LOG){
		// console.log('request set_url');
	}
	let is_json = false; //是否有其它参数
	let options = {};
	if (Object.keys(data).length > 0){
		is_json = true;
		let keys = Object.keys(data);
		keys = keys.sort();
		keys.forEach(function (val){
			options[val] = data[val];
		})
	}
	if (LOG){
		// console.log('request set_url options sort', options);
	}

	let time = new Date().getTime(); //当前时间戳

	let str = 'port='+port+'&method='+method+'&time='+time;
	if (is_json){
		let data_json = JSON.stringify(options);
		str = str + data_json;
	}
	str = str + TOKEN;
	if (LOG){
		// console.log('str 1',str);
	}
	let sing = md5(str);
	if (LOG){
		// console.log('sign=> ',sing);
	}
	let url = '';
	if (type == 'post'){
		url = 'manage.php?port='+port+'&method='+method+'&time='+time+'&sign='+sing;
	}else{
		url = 'manage.php?port='+port+'&method='+method+'&time='+time+'&sign='+sing+'&data='+encodeURIComponent(JSON.stringify(data));
	}
	if (LOG){
		// console.log('url=> ',url);
	}
	return url;
}

export default request;
